import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles'
import { validateInput } from '../../../../../../utils/input-validation'

const useStyles = makeStyles(theme => ({
	customTooltip: {
		fontSize: '1.00rem',
		whiteSpace: 'pre-line',
		textAlign: 'center',
	},
}))

export default function SubLabelType3({ type, item, onFillForm, answers, validationRules = {} }) {
	const classes = useStyles()
	const label_name = item.label_name
	const childs = item.childs

	const renderInput = (childId, fieldName, value) => {
		const { isValid, message, status } = validateInput(value, validationRules)

		let bgClass = 'bg-green_input_bg'
		if (value && status === 'error') bgClass = 'bg-red-200 border-2 border-red-500'
		else if (value && status === 'warning') bgClass = 'bg-yellow-100 border-2 border-yellow-500'

		// START OF EDITS
		const handleBlur = (e) => {
			let val = e.target.value
			if (val.startsWith('.')) {
				val = '0' + val
			}

			if (validationRules.dataType === 'float' && val !== '' && !isNaN(val)) {
				const parts = val.toString().split('.')
				const decimalLen = parts[1] ? parts[1].length : 0

				if (decimalLen < 2) {
					const formatted = parseFloat(val).toFixed(2)
					if (formatted !== e.target.value) {
						onFillForm(type, childId, fieldName, formatted)
					}
				} else if (val !== e.target.value) {
					onFillForm(type, childId, fieldName, val)
				}
			}
		}
		// END OF EDITS

		return (
			<Tooltip classes={{ tooltip: classes.customTooltip }} title={message} arrow open={!!message && !!value}>
				<Input
					className={`border-r border-gray-500 p-1 font-bold text-center ${bgClass}`}
					value={value}
					onChange={e =>
						onFillForm(type, childId, fieldName, e.target.value)
					}
					onBlur={handleBlur}
					type="text"
					error={status === 'error' && !!value}
				/>
			</Tooltip>
		)
	}

	return (
		<Grid className="col-span-12  text-center border flex flex-row ">
			{/* Region */}
			<Grid className="w-1/12 text-center flex justify-center items-center border-r font-bold">
				<Grid>{label_name}</Grid>
			</Grid>

			<Grid className="w-3/12  flex flex-col border-r">
				{childs.map((child, index) => (
					<Grid
						key={item.label_name + child + index}
						className="p-1 border-b h-full font-bold">
						{child.label}
					</Grid>
				))}
			</Grid>

			{/* Months */}
			<Grid className="w-2/12 flex flex-col">
				{childs.map((child, index) => {
					const answer = answers.find(ans => ans.DataSetItemID === child.id)
					return (
						<div key={item.label_name + index + 'input-month1'}>
							{renderInput(child.id, 'DataValueMonth1', answer?.DataValueMonth1)}
						</div>
					)
				})}
			</Grid>
			<Grid className="w-2/12 flex flex-col">
				{childs.map((child, index) => {
					const answer = answers.find(ans => ans.DataSetItemID === child.id)
					return (
						<div key={item.label_name + index + 'input-month2'}>
							{renderInput(child.id, 'DataValueMonth2', answer?.DataValueMonth2)}
						</div>
					)
				})}
			</Grid>
			<Grid className="w-2/12 flex flex-col">
				{childs.map((child, index) => {
					const answer = answers.find(ans => ans.DataSetItemID === child.id)
					return (
						<div key={item.label_name + index + 'input-month3'}>
							{renderInput(child.id, 'DataValueMonth3', answer?.DataValueMonth3)}
						</div>
					)
				})}
			</Grid>

			{/* Average */}
			<Grid className="w-2/12 flex flex-col">
				{childs.map((child, index) => {
					const answer = answers.find(ans => ans.DataSetItemID === child.id)
					return (
						<div key={item.label_name + index + 'input_avg'}>
							{renderInput(child.id, 'DataValueMonthAvg', answer?.DataValueMonthAvg)}
						</div>
					)
				})}
			</Grid>
		</Grid>
	)
}
